<template>
  <div class="container">
    <div class="header_search">
      <div class="search">
        <el-input
          size="small"
          :placeholder="$t('account.search_ph')"
          v-model="searchKey"
          class="input-with-select"
        >
          <el-button
            size="small"
            slot="append"
            icon="el-icon-search"
            style="background-color: #5a9cf8; color: #fff"
            @click="search"
          ></el-button>
        </el-input>
      </div>
      <div class="addBtn">
        <el-select size="small" v-model="status" @change="selectChange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option
        ></el-select>
      </div>
    </div>
    <div class="table_container">
      <el-table ref="table" height="100%" :data="tableData">
        <!-- prop="projects" -->
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="name"
          :label="$t('account.project_name')"
          width="280"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row}} -->
            {{ scope.row.projectName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="phoneNum"
          :label="$t('account.register_num')"
          width="180"
        >
        </el-table-column>
        <el-table-column align="center" prop="createdAt" :label="$t('account.apply_time')">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createdAt, $i18n.locale) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="status" :label="$t('account.current_status')">
          <template slot-scope="scope">
            <span
              :style="{
                color:
                  scope.row.status == 0
                    ? '#EA6F00'
                    : scope.row.status == 1
                    ? '#EA0000'
                    : '#70B500',
              }"
            >
              {{
                scope.row.status == 0
                  ? $t("account.status_pending")
                  : scope.row.status == 1
                  ? $t("account.status_frozen")
                  : $t("account.status_active")
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('public.operation')">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="editAccount(scope.row)"
              size="mini"
            >
              {{ $t("public.edit") }}
            </el-button>
            <el-button
              v-if="scope.row.status == 0"
              type="primary"
              @click="accountOption(0, scope.row)"
              size="mini"
            >
              {{ $t("account.pass") }}
            </el-button>
            <el-button
              v-else-if="scope.row.status == 2"
              type="danger"
              @click="accountOption(2, scope.row)"
              size="mini"
            >
              {{ $t("account.freeze") }}
            </el-button>
            <el-button
              v-else
              type="success"
              @click="accountOption(1, scope.row)"
              size="mini"
            >
              {{ $t("account.unfreeze") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div style="width: 100%;background: #ffffff;padding: 10px;display: flex;justify-content: flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
        >
        </el-pagination>
      </div> -->
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[15, 30, 50, 100]"
        :page-size="pageSize"
        :current-page="page"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <AuditAccount
      :show.sync="show"
      :content="content"
      :type="type"
      :rowInfo="rowInfo"
      @refush="handleSizeChange"
    ></AuditAccount>
    <editAccount
      :show.sync="showEdit"
      :rowInfo="accountInfo"
      @refush="handleSizeChange"
    ></editAccount>
  </div>
</template>

<script>
import AuditAccount from "./components/auditAccount.vue";
import editAccount from "./components/editAccount.vue";
import { accountList } from "@/api/index";
import { formatDateTime } from "@/utils/time";
export default {
  name: "OpenWebPermissionManage",
  components: {
    AuditAccount,
    editAccount,
  },
  data() {
    return {
      accountInfo: {},
      rowInfo: {},
      showEdit: false,
      // roles: JSON.parse(localStorage.getItem(("userInfo"))).roleIds,
      type: 0,
      show: false,
      status: "-1", // 状态
      searchKey: "",
      page: 1,
      pageSize: 15,
      total: 0,
      form: {
        sn: "",
        name: "",
      },
      tableData: [
        {
          date: "2016-05-03",
          name: "最后一个name",
          status: 0,
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  computed: {
    content() {
      if (this.type === 0) return this.$t("account.pass_confirm");
      if (this.type === 2) return this.$t("account.freeze_confirm");
      return this.$t("account.unfreeze_confirm");
    },
    // options 转 computed：状态筛选项随语言热切换
    options() {
      return [
        { value: "-1", label: this.$t("public.all") },
        { value: "0", label: this.$t("account.status_pending") },
        { value: "2", label: this.$t("account.status_active") },
        { value: "1", label: this.$t("account.status_frozen") },
      ];
    },
  },
  mounted() {
    this.getList();
  },
  activated() {
    this.getList();
  },
  methods: {
    formatDateTime,
    editAccount(row) {
      this.accountInfo = row;
      this.showEdit = true;
    },
    selectChange() {
      this.page = 1;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    // 账号审核 0 通过 1 冻结 2 解冻
    accountOption(type, row) {
      this.rowInfo = row;
      this.type = type;
      this.show = true;
    },
    handleSizeChange(e) {
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getList();
    },
    async getList() {
      this.tableData = [];
      let param = {
        keyword: this.searchKey,
        status: this.status,
        limit: this.pageSize,
        page: this.page,
      };
      let res = await accountList(param);
      this.total = res.data.total;
      console.log(res, "获取列表数据");
      res.data.list = res.data.list.map((item) => {
        let name = "";
        if (item.projects) {
          item.projects.forEach((it) => {
            name += it.name + "、";
          });
        }
        return {
          ...item,
          name: name.slice(0, -1),
        };
      });
      this.tableData = res.data.list;
      console.log(this.tableData, "获取列表数据");
      // console.log(this.tableData, "获取列表数据");
    },
    // search() {
    //   console.log("搜索", this.searchKey);
    // },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #ecf0f3;
  padding: 10px;
  .header_search {
    display: flex;
    align-items: center;
    height: 72px;
    width: 100%;
    background-color: #fff;
    padding: 10px;
    .search {
      width: 252px;
    }
    .addBtn {
      margin-left: 60px;
      min-width: 32px;
    }
  }
  .table_container {
    width: 100%;
    // height: calc(100% - 72px - 10px);
    height: calc(100% - 72px - 10px - 40px);
    margin-top: 10px;
    background-color: #ffffff;
  }
}
.flex_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep {
  .el-dialog--center .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }
  .el-table th.el-table__cell {
    background-color: #f4f7fa;
  }
  // .el-dialog--center .el-dialog__body {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   min-height: 200px;
  // }
  // .el-table th.el-table__cell {
  //   background-color: #f4f7fa;
  // }
  // .el-dialog__header {
  //   border-bottom: 1px solid #eeeeee;
  // }
  // .el-dialog__footer {
  //   border-top: 1px solid #eeeeee;
  // }
}
</style>